import { Button } from '@bdo/kitchensink';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { Icon } from '@fluentui/react/lib/Icon';

export default function BackButton({ url = '/', type = 'danger', iconName = 'Back', ...props }) {

    const navigate = useNavigate();
    const { state } = useLocation();    

    function handleBack() {
        const getParameters = new URLSearchParams(window.location.search);
        var backUrl = getParameters.get('backUrl');
        if (backUrl) {
            navigate(backUrl);
        }
        else {
            navigate(url, { state: state});
        }
    }

    return (
        <Button
            type={type}
            icon={<Icon iconName={iconName} />}
            onClick={handleBack}
            {...props}
        >
            { props.children }
        </Button>
    );
}
